import React from 'react';
import Horarios from "../../Components/Lista/Horarios";
import styled from "styled-components";

const Text=styled.h1`
margin:0;
justify-self:center;
font-size:24px;`;

const SubText=styled.h3`
text-align:center;
margin:0;
margin-top: 1rem;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}`;

const StatusLapiz = ({Logo}) => 
{
    return <>
        {Logo}
        <Text>Lista de espera</Text>
        <SubText style={{marginTop:"20px", padding:"0px 30px", fontSize:"20px"}}>Hoy nos abandonó la tecnología 😥</SubText>
        <SubText style={{marginTop:"20px", padding:"0px 30px", fontSize:"20px"}}>La lista de espera hoy es presencial, los esperamos!</SubText>
        <Horarios/>
    </>
}

export default StatusLapiz
